var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScreenshot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#699D8C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 16.25H11.5V18.5H9V19.5H15V18.5H12.5V16.25H18.75C18.9488 16.2498 19.1395 16.1707 19.2801 16.0301C19.4207 15.8895 19.4998 15.6988 19.5 15.5V6.25C19.4998 6.05116 19.4207 5.86053 19.2801 5.71993C19.1395 5.57932 18.9488 5.50023 18.75 5.5H5.25C5.05116 5.50023 4.86053 5.57932 4.71993 5.71993C4.57932 5.86053 4.50023 6.05116 4.5 6.25V15.5C4.50023 15.6988 4.57932 15.8895 4.71993 16.0301C4.86053 16.1707 5.05116 16.2498 5.25 16.25ZM5.5 6.5H18.5V15.25H5.5V6.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0234 14.0248H15.9038C16.7038 14.0248 17.0237 13.7048 17.0237 12.9048L17.0234 12.0248",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8H8.11969C7.31969 8 6.99969 8.32 6.99969 9.12L7 10",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshot);
export default __webpack_public_path__ + "static/media/screenshot.62efeb69473dfa7ab76bef1c8ee31a34.svg";
export { ForwardRef as ReactComponent };